import { schema } from 'normalizr';
import { skillList } from './skill';

export const compliance = new schema.Entity('compliance', { skills: skillList }, {
    processStrategy: ({id, skills, userCount, ...value}) => ({
        id: Number(id),
        skills: skills || [],
        userCount: Number(userCount),
        skillCount: skills ? skills.length : 0,
        ...value
    })
});

export const complianceList = [ compliance ];
